import { useQuery } from '@tanstack/vue-query';
import { ref } from 'vue';
import { ChargingStation, mapToDomain } from '@infuse/e-connector/charging-station/domain';
import { getChargingStation } from '@infuse/api/e-connector/charging-station';

export const useChargingStation = () => {
  const fetchChargingStationId = ref<string | undefined>(undefined);

  const query = useQuery<ChargingStation>({
    queryKey: ['charging-stations', 'detail', fetchChargingStationId],
    enabled: () => !!fetchChargingStationId.value,
    queryFn: async () => {
      const response = await getChargingStation({ id: fetchChargingStationId.value });
      return mapToDomain(response);
    }
  });

  return {
    ...query,
    fetchChargingStationId,
    chargingStation: query.data
  };
};
